import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoggerService } from '@app/services/logger.service';
import { PermHelperService, PermissionCondition } from '@app/services/perm-helper.service';
import { ControlPageFacade } from '@ra-state';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly permissionHelper = inject(PermHelperService);
  private readonly controlPageFacade = inject(ControlPageFacade);

  logger = inject(LoggerService).withContext(PermGuard);
  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredPerms = route.data['requiredPerms'] as PermissionCondition;
    this.logger.debug('Required Permissions', requiredPerms);
    return this.permissionHelper.checkPermission$(requiredPerms).pipe(
      map((hasAccess) => {
        if (hasAccess) {
          return true;
        }
        const requiresHomeRedirect = this.router.url === '/' || this.router.url === '';
        const errorMessage = requiresHomeRedirect
          ? 'Insufficient Permissions. Redirecting to Home page.'
          : 'Insufficient Permissions.';
        this.controlPageFacade.setPermissionDenied(errorMessage, () => {
          if (requiresHomeRedirect) {
            this.router.navigate(['/home']);
          }
        });
        return false;
      }),
    );
  }
}
